import React, { FC } from 'react';

import Styled from './styles';
import { IProps } from './styles';

export const Typography: FC<IProps> = ({
	children,
	type,
	size,
	color,
	text = '',
	numberOfLines,
	...rest
}) => {
	const content = text ? text : children;

	return (
		<Styled.Text
			numberOfLines={numberOfLines}
			type={type || 'primary'}
			size={size || 'medium'}
			color={color}
			{...rest}
		>
			{content}
		</Styled.Text>
	);
};
